import('../src/javascripts/easy-toggle');
import('../src/javascripts/attachments-redesign');
import('../src/javascripts/navigation');
